import { Box, Button, Dialog, Text, TextField } from '@radix-ui/themes';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { Pen } from 'lucide-react';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import {
  CardTypeResponse,
  CreateCardTypeRequest,
} from '../../model/Card-type.model';
import CardTypeService from '../../service/card-type-service/Card-type.service';

interface EditCardTypeModalProps {
  cardType: CardTypeResponse;
  onSuccess: () => void;
}

const EditCardTypeModal: React.FC<EditCardTypeModalProps> = ({
  cardType,
  onSuccess,
}) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<CreateCardTypeRequest>({
    name: cardType.name,
  });

  const screens = useBreakpoint();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await CardTypeService.updateCardType(cardType.cardTypeId, formData);
      toast.success('Cập nhật loại thẻ thành công!');
      onSuccess();
      setOpen(false);
    } catch (error: any) {
      console.error('Error updating card type:', error);
      toast.error(error.message || 'Có lỗi xảy ra khi cập nhật loại thẻ!');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger>
        <Button variant="ghost" color="indigo" className="cursor-pointer">
          <Pen size={18} />
        </Button>
      </Dialog.Trigger>

      <Dialog.Content style={{ maxWidth: screens.xs ? '95%' : 700 }}>
        <Dialog.Title>Chỉnh sửa loại thẻ</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          Điền đầy đủ các thông tin
        </Dialog.Description>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Box className="space-y-4">
            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Tên loại thẻ <span className="text-red-500">*</span>
              </Text>
              <TextField.Root
                name="name"
                placeholder="Nhập tên loại thẻ"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
          </Box>

          <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-2 pt-4">
            <Dialog.Close>
              <Button
                variant="soft"
                color="gray"
                className="cursor-pointer w-full sm:w-auto"
              >
                Hủy
              </Button>
            </Dialog.Close>
            <Button
              color="indigo"
              variant="soft"
              type="submit"
              className="cursor-pointer w-full sm:w-auto"
            >
              Hoàn thành
            </Button>
          </div>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default EditCardTypeModal;
